webpackJsonp([114276838955818,60335399758886],{

/***/ 152:
/***/ (function(module, exports) {

	module.exports = {"layoutContext":{}}

/***/ }),

/***/ 325:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__(330);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _layoutIndex = __webpack_require__(152);
	
	var _layoutIndex2 = _interopRequireDefault(_layoutIndex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(_index2.default, _extends({}, props, _layoutIndex2.default));
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 760:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var GoogleFont = function GoogleFont(props) {
	  // Create family + styles string
	  var fontsStr = "";
	  if (props.typography.options.googleFonts) {
	    var fonts = props.typography.options.googleFonts.map(function (font) {
	      var str = "";
	      str += font.name.split(" ").join("+");
	      str += ":";
	      str += font.styles.join(",");
	
	      return str;
	    });
	
	    fontsStr = fonts.join("|");
	
	    if (fontsStr) {
	      return _react2.default.createElement("link", {
	        href: "//fonts.googleapis.com/css?family=" + fontsStr,
	        rel: "stylesheet",
	        type: "text/css"
	      });
	    }
	    return null;
	  }
	};
	
	GoogleFont.propTypes = {
	  typography: _propTypes2.default.object.isRequired
	};
	
	GoogleFont.displayName = "GoogleFont";
	
	module.exports = GoogleFont;

/***/ }),

/***/ 761:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TypographyStyle = function TypographyStyle(props) {
	  return _react2.default.createElement("style", {
	    id: "typography.js",
	    dangerouslySetInnerHTML: {
	      __html: props.typography.toString()
	    }
	  });
	};
	
	TypographyStyle.propTypes = {
	  typography: _propTypes2.default.object.isRequired
	};
	
	TypographyStyle.displayName = "TypographyStyle";
	
	module.exports = TypographyStyle;

/***/ }),

/***/ 762:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _GoogleFont = __webpack_require__(760);
	
	var _GoogleFont2 = _interopRequireDefault(_GoogleFont);
	
	var _TypographyStyle = __webpack_require__(761);
	
	var _TypographyStyle2 = _interopRequireDefault(_TypographyStyle);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = {
	  GoogleFont: _GoogleFont2.default,
	  TypographyStyle: _TypographyStyle2.default
	};

/***/ }),

/***/ 812:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/footer_bg.fcc616e0.jpg";

/***/ }),

/***/ 816:
/***/ (function(module, exports) {

	module.exports = "data:image/jpeg;base64,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"

/***/ }),

/***/ 817:
/***/ (function(module, exports) {

	module.exports = "data:image/jpeg;base64,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"

/***/ }),

/***/ 818:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAO1JREFUeNpi/P//PwM1ABMDlQDVDGIBEes3b6fIkEBfT9p4LR+IXwHxfyLwNyB+CMSK2AxyBeKJQNxBwPJ3QOwPxK+BWAtXYLcA8S8gLsZhyAsgDgXidiA2JhRrdVAnxwHxXyTxO1BDpqEbgi/6c6BeBWn8DsQXgDgRiJcCsTrO6McCPkLpBCD2hLIXAfE+qBhRBoEM6QbiaiDmBGJ+qCskoGE0C4jTCHkNZEgfkiEgYA81BAQsgVgXiKfjcxHIkPVAXIFkCDYAMowZiI9DYxjDoCZoIC8mMjE/AuKD2Ay6CcS55GYRxkFXHgEEGAB/3zh2APPOdQAAAABJRU5ErkJggg=="

/***/ }),

/***/ 819:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAARCAYAAAA7bUf6AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAQ5JREFUeNpi/P//PwMIrN+8nYFUEOjrCaaZcMgLAXEdEN8AYpAt54G4FIj5sSlmwSJmDMRbgFgCScwAijOB2A2I7yBrQHcJDxBvRDMAGShC5ZnxGZIAxNJQ9msgdgBiRiD2AeIvUHEtIPbGZ4gTErsbiA9C2VuBeDqSnAc+Q6SR2H/R5JhxqMMI2NdI7GogfgrER6AuzMGhDsOQg0j+BUXzChwBfASfdxYD8S8CaewjEK/EZ8gLIF5AwJAOIP6OzxAQaEKKTnQACqMp6IJMOBS24jCkBpsFuPJOHxBfwxLoi7EpxmUIKHDjkAIZZHsilrSD1xAQOAsNRBAoAOL7uBSyEIiJVmhKnYtPEUCAAQAP3jSXUs36DwAAAABJRU5ErkJggg=="

/***/ }),

/***/ 820:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAPlJREFUeNpiXLdpGwOlINDXk4EJTUwRiNOgNEmABYmtBcTngZgNiOcCcQopBiG7KAdqCAiEAzEPuQZpIbFBhsSSa9BrNDl7cg3ajcR+CsTF5Bq0AGoACNxBYpNs0C8grkHyVhq5BoHAYiDeBGVPAGIzcg36C8RxQHwZiDmBeC8QeyDJGwCxLjEGgcBHIPaEhhMoGWwH4jlQr54B4ktAfAyIE6CW4TQIFmvmQHwQyk8G4plAzAzlWwLxfCDeQsggEHgHxG5A3A2NCGzgETEGwWKyDIg1oBHxHSksQZFST6xBMHAfGglcUENBmd2fFBdhAzeJjTWyAECAAQA0sS0NOxk6TwAAAABJRU5ErkJggg=="

/***/ }),

/***/ 831:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/logo.e611805a.jpg";

/***/ }),

/***/ 328:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  background-image: url(', ');\n  background-size: cover;\n  background-position: top center;\n  min-height: 435px;\n'], ['\n  background-image: url(', ');\n  background-size: cover;\n  background-position: top center;\n  min-height: 435px;\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  display: flex;\n  justify-content: space-between;\n  flex-wrap: wrap;\n'], ['\n  display: flex;\n  justify-content: space-between;\n  flex-wrap: wrap;\n']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\n  width: calc(50% - ', ');\n  min-width: 300px;\n  padding-top: ', ';\n  color: white;\n\n  & h4 {\n    font-size: ', ';\n    color: white;\n    font-weight: 400;\n    text-align: center;\n  }\n\n  & p {\n    margin-left: auto;\n    margin-right: auto;\n    display: flex;\n    width: 80%;\n\n    & span {\n      line-height: 1.4\n    }\n\n    & a {\n      color: currentColor;\n      text-decoration: none;\n    }\n  }\n\n  & .info-bar {\n    padding: ', ' ', ';\n    justify-content: center;\n    background-color: #333;\n    border-radius: 4px;\n  }\n\n  & img {\n    margin-right: ', ';\n    position: relative;\n    top: 0px;\n    user-select: none;\n  }\n\n  & .fb-footer {\n    margin: 0 auto;\n    width: 300px;\n  }\n'], ['\n  width: calc(50% - ', ');\n  min-width: 300px;\n  padding-top: ', ';\n  color: white;\n\n  & h4 {\n    font-size: ', ';\n    color: white;\n    font-weight: 400;\n    text-align: center;\n  }\n\n  & p {\n    margin-left: auto;\n    margin-right: auto;\n    display: flex;\n    width: 80%;\n\n    & span {\n      line-height: 1.4\n    }\n\n    & a {\n      color: currentColor;\n      text-decoration: none;\n    }\n  }\n\n  & .info-bar {\n    padding: ', ' ', ';\n    justify-content: center;\n    background-color: #333;\n    border-radius: 4px;\n  }\n\n  & img {\n    margin-right: ', ';\n    position: relative;\n    top: 0px;\n    user-select: none;\n  }\n\n  & .fb-footer {\n    margin: 0 auto;\n    width: 300px;\n  }\n']),
	    _templateObject4 = _taggedTemplateLiteralLoose(['\n  text-align: center;\n  padding: ', ' ', ' ', ';\n  color: white;\n  margin: 0;\n  font-size: ', ';\n'], ['\n  text-align: center;\n  padding: ', ' ', ' ', ';\n  color: white;\n  margin: 0;\n  font-size: ', ';\n']);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styledComponents = __webpack_require__(36);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _gatsbyLink = __webpack_require__(11);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactFacebook = __webpack_require__(289);
	
	var _reactFacebook2 = _interopRequireDefault(_reactFacebook);
	
	var _styles = __webpack_require__(44);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	var _typography = __webpack_require__(21);
	
	var _layouts = __webpack_require__(20);
	
	var _footer_bg = __webpack_require__(812);
	
	var _footer_bg2 = _interopRequireDefault(_footer_bg);
	
	var _iconPhone = __webpack_require__(820);
	
	var _iconPhone2 = _interopRequireDefault(_iconPhone);
	
	var _iconMail = __webpack_require__(818);
	
	var _iconMail2 = _interopRequireDefault(_iconMail);
	
	var _iconMap = __webpack_require__(819);
	
	var _iconMap2 = _interopRequireDefault(_iconMap);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var TheFooter = _styledComponents2.default.div(_templateObject, _footer_bg2.default);
	var ContainerF = _layouts.Container.extend(_templateObject2);
	
	var FooterColumn = _styledComponents2.default.div(_templateObject3, (0, _typography.rhythm)(1 / 2), (0, _typography.rhythm)(1.3), (0, _typography.rhythm)(1.3), (0, _typography.rhythm)(0.5), (0, _typography.rhythm)(1), (0, _typography.rhythm)(0.5));
	
	var Copyright = _styledComponents2.default.p(_templateObject4, (0, _typography.rhythm)(2), (0, _typography.rhythm)(1), (0, _typography.rhythm)(1), (0, _typography.rhythm)(0.75));
	
	var Footer = function (_React$Component) {
	  _inherits(Footer, _React$Component);
	
	  function Footer() {
	    _classCallCheck(this, Footer);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Footer.prototype.render = function render() {
	    return _react2.default.createElement(
	      TheFooter,
	      null,
	      _react2.default.createElement(
	        ContainerF,
	        null,
	        _react2.default.createElement(
	          FooterColumn,
	          null,
	          _react2.default.createElement(
	            'h4',
	            null,
	            'Info'
	          ),
	          _react2.default.createElement(
	            'p',
	            { className: 'info-bar' },
	            'TIETOA MINUSTA'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            _react2.default.createElement('img', { src: _iconPhone2.default }),
	            ' ',
	            _react2.default.createElement(
	              'a',
	              { href: 'tel:050-5288861' },
	              '050-5288861'
	            )
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            _react2.default.createElement('img', { src: _iconMail2.default }),
	            _react2.default.createElement(
	              'a',
	              { href: 'mailto:info@kirstilouko.com' },
	              'info@kirstilouko.com'
	            )
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            _react2.default.createElement('img', { src: _iconMap2.default }),
	            ' ',
	            _react2.default.createElement(
	              'span',
	              null,
	              'Ruukintie 25 ',
	              _react2.default.createElement('br', null),
	              '60100 Sein\xE4joki '
	            )
	          )
	        ),
	        _react2.default.createElement(
	          FooterColumn,
	          null,
	          _react2.default.createElement(
	            'h4',
	            null,
	            'Facebook'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'fb-footer' },
	            _react2.default.createElement(
	              _reactFacebook2.default,
	              { appId: '114390019275615' },
	              _react2.default.createElement(_reactFacebook.Page, { href: 'https://www.facebook.com/Terapiapalvelu-Kirsti-Louko-156979377673908/', width: '528' })
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        Copyright,
	        null,
	        'Copyright 2022 Terapiapalvelu Kirsti Louko. All Rights Reserved.\u200B'
	      )
	    );
	  };
	
	  return Footer;
	}(_react2.default.Component);
	
	exports.default = Footer;
	module.exports = exports['default'];

/***/ }),

/***/ 329:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  display: flex;\n  align-items: center;\n  height: ', ';\n\n  @media (max-width: 400px) {\n    flex-flow: column;\n    height: auto;\n    align-items: flex-start;\n  }\n\n  @media (min-width: 401px) and (max-width: 800px) {\n    flex-wrap: wrap;\n  }\n'], ['\n  display: flex;\n  align-items: center;\n  height: ', ';\n\n  @media (max-width: 400px) {\n    flex-flow: column;\n    height: auto;\n    align-items: flex-start;\n  }\n\n  @media (min-width: 401px) and (max-width: 800px) {\n    flex-wrap: wrap;\n  }\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  margin-right: auto;\n  width: 100%;\n  & img {\n    margin-bottom: auto;\n  }\n  @media (max-width: 400px) {\n    margin-top: ', ';\n  }\n'], ['\n  margin-right: auto;\n  width: 100%;\n  & img {\n    margin-bottom: auto;\n  }\n  @media (max-width: 400px) {\n    margin-top: ', ';\n  }\n']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\n  width: 300px;\n  display: flex;\n  align-items: center;\n  margin-left: ', ';\n\n  @media (max-width: 400px) {\n    margin-left: 0;\n  }\n\n\n  & img {\n    margin: auto 0 auto auto;\n    width: 43px;\n    height: 40px;\n  }\n\n  & .info {\n    color: ', ';\n    margin-left: ', ';\n    display: flex;\n    flex-flow: column;\n  }\n\n  & a {\n    text-decoration: none;\n    font-weight: bold;\n    color: black;\n  }\n'], ['\n  width: 300px;\n  display: flex;\n  align-items: center;\n  margin-left: ', ';\n\n  @media (max-width: 400px) {\n    margin-left: 0;\n  }\n\n\n  & img {\n    margin: auto 0 auto auto;\n    width: 43px;\n    height: 40px;\n  }\n\n  & .info {\n    color: ', ';\n    margin-left: ', ';\n    display: flex;\n    flex-flow: column;\n  }\n\n  & a {\n    text-decoration: none;\n    font-weight: bold;\n    color: black;\n  }\n']),
	    _templateObject4 = _taggedTemplateLiteralLoose(['\n  background-color: ', ';\n\n  @media (min-width: 800px) {\n    height: ', ';\n  }\n'], ['\n  background-color: ', ';\n\n  @media (min-width: 800px) {\n    height: ', ';\n  }\n']),
	    _templateObject5 = _taggedTemplateLiteralLoose(['\n  display: flex;\n  flex-flow: column;\n\n  @media (min-width: 400px) {\n    align-items: stretch;\n    flex-flow: row;\n    height: 100%;\n  }\n\n  @media (min-width: 400px) and (max-width: 799px) {\n    flex-flow: wrap;\n  }\n\n  & li {\n    list-style: none;\n    flex-grow: 1;\n    display: flex;\n    margin-bottom: 0;\n\n    @media (min-width: 400px) and (max-width: 799px) {\n      width: 200px;\n    }\n\n    @media (max-width: 799px) {\n      height: ', ';\n    }\n  }\n\n  & a {\n    color: white;\n    font-style: normal;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    text-transform: center;\n    text-decoration: none;\n    margin: 0 auto;\n    width: 90%;\n    transition: all 150ms ease-in-out;\n\n\n    &:hover,\n    &:focus,\n    &:active,\n    &.active {\n      width: 100%;\n      background-color: white;\n      color: ', ';\n    }\n  }\n'], ['\n  display: flex;\n  flex-flow: column;\n\n  @media (min-width: 400px) {\n    align-items: stretch;\n    flex-flow: row;\n    height: 100%;\n  }\n\n  @media (min-width: 400px) and (max-width: 799px) {\n    flex-flow: wrap;\n  }\n\n  & li {\n    list-style: none;\n    flex-grow: 1;\n    display: flex;\n    margin-bottom: 0;\n\n    @media (min-width: 400px) and (max-width: 799px) {\n      width: 200px;\n    }\n\n    @media (max-width: 799px) {\n      height: ', ';\n    }\n  }\n\n  & a {\n    color: white;\n    font-style: normal;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    text-transform: center;\n    text-decoration: none;\n    margin: 0 auto;\n    width: 90%;\n    transition: all 150ms ease-in-out;\n\n\n    &:hover,\n    &:focus,\n    &:active,\n    &.active {\n      width: 100%;\n      background-color: white;\n      color: ', ';\n    }\n  }\n']);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styledComponents = __webpack_require__(36);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _gatsbyLink = __webpack_require__(11);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _typographyBreakpointConstants = __webpack_require__(316);
	
	var _styles = __webpack_require__(44);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	var _typography = __webpack_require__(21);
	
	var _layouts = __webpack_require__(20);
	
	var _logo = __webpack_require__(831);
	
	var _logo2 = _interopRequireDefault(_logo);
	
	var _iconEmail = __webpack_require__(816);
	
	var _iconEmail2 = _interopRequireDefault(_iconEmail);
	
	var _iconPhone = __webpack_require__(817);
	
	var _iconPhone2 = _interopRequireDefault(_iconPhone);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var HeaderContainer = _styledComponents2.default.div(_templateObject, (0, _typography.rhythm)(6));
	var Logo = _styledComponents2.default.div(_templateObject2, (0, _typography.rhythm)(1));
	
	var ContactBlock = _styledComponents2.default.div(_templateObject3, (0, _typography.rhythm)(1), _styles2.default.green, (0, _typography.rhythm)(0.5));
	
	var MainMenu = _styledComponents2.default.div(_templateObject4, _styles2.default.green, (0, _typography.rhythm)(3));
	
	var MenuUl = _layouts.Container.withComponent('ul').extend(_templateObject5, (0, _typography.rhythm)(2), _styles2.default.green);
	
	var Header = function (_React$Component) {
	  _inherits(Header, _React$Component);
	
	  function Header() {
	    _classCallCheck(this, Header);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Header.prototype.render = function render() {
	    var isHome = this.props.isHome;
	
	
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        _layouts.Container,
	        null,
	        _react2.default.createElement(
	          HeaderContainer,
	          null,
	          _react2.default.createElement(
	            Logo,
	            null,
	            isHome ? _react2.default.createElement('img', { src: _logo2.default, alt: 'Kirstilouko', className: 'logo' }) : _react2.default.createElement(
	              _gatsbyLink2.default,
	              { to: '/' },
	              _react2.default.createElement('img', { src: _logo2.default, alt: 'Kirstilouko', className: 'logo' })
	            )
	          ),
	          _react2.default.createElement(
	            ContactBlock,
	            null,
	            _react2.default.createElement('img', { src: _iconEmail2.default, alt: 'Email icon' }),
	            _react2.default.createElement(
	              'div',
	              { className: 'info' },
	              _react2.default.createElement(
	                'span',
	                { className: 'title' },
	                'L\xE4het\xE4 s\xE4hk\xF6postia'
	              ),
	              _react2.default.createElement(
	                'a',
	                { href: 'mailto:info@kirstilouko.com' },
	                'info@kirstilouko.com'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            ContactBlock,
	            null,
	            _react2.default.createElement('img', { src: _iconPhone2.default, alt: 'Phone icon' }),
	            _react2.default.createElement(
	              'div',
	              { className: 'info' },
	              _react2.default.createElement(
	                'span',
	                { className: 'title' },
	                'Soita'
	              ),
	              _react2.default.createElement(
	                'a',
	                { href: 'tel:050-5288861' },
	                '050-5288861'
	              )
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        MainMenu,
	        null,
	        _react2.default.createElement(
	          MenuUl,
	          null,
	          _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              _gatsbyLink2.default,
	              { to: '/' },
	              'ETUSIVU'
	            )
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              _gatsbyLink2.default,
	              { to: '/psykoterapia', activeClassName: 'active' },
	              'PSYKOTERAPIA'
	            )
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              _gatsbyLink2.default,
	              { to: '/seksuaalineuvonta', activeClassName: 'active' },
	              'SEKSUAALINEUVONTA'
	            )
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              _gatsbyLink2.default,
	              { to: '/tyonohjaus', activeClassName: 'active' },
	              'TY\xD6NOHJAUS'
	            )
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              _gatsbyLink2.default,
	              { to: '/hinnasto', activeClassName: 'active' },
	              'HINNASTO'
	            )
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              _gatsbyLink2.default,
	              { to: '/yhteystiedot', activeClassName: 'active' },
	              'YHTEYSTIEDOT'
	            )
	          )
	        )
	      )
	    );
	  };
	
	  return Header;
	}(_react2.default.Component);
	
	exports.default = Header;
	module.exports = exports['default'];

/***/ }),

/***/ 330:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _gatsbyLink = __webpack_require__(11);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactHelmet = __webpack_require__(34);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _reactTypography = __webpack_require__(762);
	
	var _typography = __webpack_require__(21);
	
	var _typography2 = _interopRequireDefault(_typography);
	
	__webpack_require__(444);
	
	__webpack_require__(443);
	
	var _layouts = __webpack_require__(20);
	
	var _header = __webpack_require__(329);
	
	var _header2 = _interopRequireDefault(_header);
	
	var _footer = __webpack_require__(328);
	
	var _footer2 = _interopRequireDefault(_footer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TemplateWrapper = function (_React$Component) {
	  _inherits(TemplateWrapper, _React$Component);
	
	  function TemplateWrapper() {
	    _classCallCheck(this, TemplateWrapper);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  TemplateWrapper.prototype.render = function render() {
	    var _props = this.props,
	        children = _props.children,
	        location = _props.location;
	
	
	    var isHome = location.pathname === '/';
	
	    return _react2.default.createElement(
	      _layouts.Site,
	      null,
	      _react2.default.createElement(_reactTypography.TypographyStyle, { typography: _typography2.default }),
	      _react2.default.createElement(_reactTypography.GoogleFont, { typography: _typography2.default }),
	      _react2.default.createElement(_reactHelmet2.default, {
	        title: 'Kirsti Louko',
	        meta: [{ name: 'description', content: 'Kokonaisvaltaista hyvinvointia' }, { name: 'keywords', content: 'psykoterapia, nettiterapia, työnohjaus, seksuaalineuvonta' }]
	      }),
	      _react2.default.createElement(_header2.default, { isHome: isHome }),
	      _react2.default.createElement(
	        _layouts.Container,
	        null,
	        children()
	      ),
	      _react2.default.createElement(_footer2.default, null)
	    );
	  };
	
	  return TemplateWrapper;
	}(_react2.default.Component);
	
	TemplateWrapper.propTypes = {
	  children: _propTypes2.default.func
	};
	
	exports.default = TemplateWrapper;
	module.exports = exports['default'];

/***/ }),

/***/ 443:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 444:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ })

});


// WEBPACK FOOTER //
// component---src-layouts-index-js-21ed77b2af24d25aeb23.js